import { PageQuery } from "../../../../utils/models/pageQuery";
import type { FilterChangeEvent } from "../../../components/GenericTable/SubComponents/TableHeader/ListHeader";

// "Only show my designs" (ListHeader's checkbox) writes the filter key
// showOnlyOwned. That key exists only in the frontend: the design and logo
// lists translate it to mainOrganizationId before their API call, and the
// API has no such field - GET/POST organizations/orders answers 500
// ("'showOnlyOwned' is not a member of type KitMaker.Model.Context.Order")
// when it arrives as a generic filter. The order list never translates it,
// so it must never reach the API from here: neither from the header's
// active filters nor from a URL/state that still carries it (deep link,
// Back/Forward, a bookmark from before the fix).
export const SHOW_ONLY_OWNED_FILTER_KEY = "showOnlyOwned";

type ActiveFilters = FilterChangeEvent["activeFilters"];

export function stripShowOnlyOwnedFilters(
  activeFilters: ActiveFilters,
): ActiveFilters {
  return activeFilters.filter((f) => f.key !== SHOW_ONLY_OWNED_FILTER_KEY);
}

// Returns the SAME query object when there is nothing to strip, so callers
// keep referential stability (react-query keys, effect deps) in the normal
// case. Only filterBy is touched; page, sort and search stay as they are.
export function stripShowOnlyOwnedFromQuery(query: PageQuery): PageQuery {
  const filterBy = query.filterBy;
  if (
    !filterBy ||
    !filterBy.some((f) => f.field === SHOW_ONLY_OWNED_FILTER_KEY)
  ) {
    return query;
  }
  return {
    ...query,
    filterBy: filterBy.filter((f) => f.field !== SHOW_ONLY_OWNED_FILTER_KEY),
  };
}
